// Hide flash messages after a certain time
document.addEventListener('DOMContentLoaded', function () {
    let hideFlashMessagesTimeout = 2000; // Value in milliseconds
    let hidingAnimationDuration = 500;  // Value in milliseconds

    // Funktion zum Ausblenden der Flash-Messages
    function hideFlashMessages(timeout = 2500) {
        const flashMsgContainer = document.querySelector('.flash-msg-container');
        const flashMessages = document.querySelectorAll('.flash-msg-success, .flash-msg-error');

        flashMessages.forEach(message => {
            // Setze einen Timer zum Ausblenden des Elements
            setTimeout(() => {
                // Entferne die Animation, falls sie noch aktiv ist
                flashMsgContainer.style.animation = "none";

                // Starte die Transition für den Fade-Out
                flashMsgContainer.style.transition = "opacity 0.5s ease";  // Optionale Animation
                flashMsgContainer.style.opacity = "0";  // Transparenz auf 0 setzen

                // Entferne das Element nach der Animation komplett
                setTimeout(() => {
                    message.remove();
                    flashMsgContainer.remove();
                }, hidingAnimationDuration);
            }, timeout);
        });
    }

    // Flash-Messages nach dem Laden der Seite ausblenden (Standard: 3 Sekunden)
    hideFlashMessages(hideFlashMessagesTimeout);
});

